export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref6850.7956a65a.jpg";